import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import '../../styles/sideMenuStyle.scss';

import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';
import { ADMINISTRADOR, ADMINISTRADOR_ZONA, EMPLEADO, SYSTEM } from '../../constants/models/typeOperationRol';

export const SidebarMenu = () => {

  const { isLoggedIn, user } = useSelector( state => state.auth);
  const operationRol = isLoggedIn? user.operationRol:'---';


    return (
        <>
          <div className="d-flex flex-column align-items-center align-items-sm-start text-white min-vh-100 base-container-menu">
               <div className="pt-1 pb-1 w-100">
              <a href="/" className="d-flex align-items-center pb-1 mb-md-0 me-md-auto">
              <img src="/images/logo.jpg" className="img-fluid" alt="logo" />
              </a>
              </div>
              <ul className="nav nav-pills flex-column w-100 mb-sm-auto mb-0 ps-3 align-items-center align-items-sm-start" id="menu">
                  <li className="nav-item w-100 pt-2 pb-3 ps-3 action-link-menu">
                  <Link to='/' className="custom-text-menu h6 px-0 align-middle">
                  <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-home"></i>
                        <span className="ms-1">Inicio</span>
                    </Link>
                  </li>
                  <span className={`
                    custom-text-title-menu h5
                    ${validateAccessUser(view.VIEW_ZONE_ADMIN ,user) || validateAccessUser(view.VIEW_GROUP ,user) || validateAccessUser(view.CREATE_GROUP ,user) || validateAccessUser(view.VIEW_USER ,user) || validateAccessUser(view.UPDATE_USER, user) || validateAccessUser(view.CREATE_CONTENT, user) || validateAccessUser(view.VIEW_CONTENT, user)
                      ? 'd-inline' : 'd-none'}
                  `}>Administración</span>
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                    ${(validateAccessUser(view.VIEW_ZONE_ADMIN ,user)) && operationRol === ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenu1" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-user-friends"></i>
                        <span className="ms-1">Administrador de zona</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenu1" data-bs-parent="#menu">
                        <li className={`
                          w-100 action-link-menu pt-2 pb-3
                          ${validateAccessUser(view.VIEW_ZONE_ADMIN ,user) && operationRol === ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                        `}>
                          <Link to='/administration/admin-zone' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Ver administrador</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                    ${(validateAccessUser(view.VIEW_GROUP ,user) || validateAccessUser(view.CREATE_GROUP ,user)) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenu2" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-user-friends"></i>
                        <span className="ms-1">Grupos</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenu2" data-bs-parent="#menu">
                        <li className={`
                          w-100 action-link-menu pt-2 pb-3
                          ${validateAccessUser(view.VIEW_GROUP ,user) && operationRol !== EMPLEADO ? 'd-inline' : 'd-none'}
                        `}>
                          <Link to='/administration/groups' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Ver grupos</span>
                          </Link>
                        </li>
                        <li className={`
                          w-100 action-link-menu pt-2
                          ${validateAccessUser(view.CREATE_GROUP ,user) && operationRol === ADMINISTRADOR ? 'd-inline' : 'd-none'}
                        `}>
                          <Link to='/administration/groups/create' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Nuevo grupo</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                    ${(validateAccessUser(view.VIEW_USER ,user) || validateAccessUser(view.UPDATE_USER, user)) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenu3" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-users"></i>
                        <span className="ms-1">Representantes</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenu3" data-bs-parent="#menu">
                        <li className="w-100 action-link-menu pt-2 pb-3">
                          <Link to='/administration/users' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Ver representantes</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                    ${validateAccessUser(view.CREATE_CONTENT, user) || validateAccessUser(view.VIEW_CONTENT, user) ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenuContent" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="far fa-newspaper"></i>
                        <span className="ms-1">Contenidos</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenuContent" data-bs-parent="#menu">
                        <li className="w-100 action-link-menu pt-2 pb-3">
                          <Link to='/administration/content/marketing' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Avisos</span>
                          </Link>
                                                  </li>
                        {/* <li className="w-100 action-link-menu pt-2 pb-3" id="submenuContent" data-bs-parent="#menu">
                          <Link to='/administration/content/video' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Videos</span>
                          </Link>
                        </li> */}
                      </ul>
                  </li>
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu 
                    ${validateAccessUser(view.VIEW_TERMS_AND_CONDITIONS ,user)   ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenutermsandconditions" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3 align-items-center">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-file-invoice"></i>
                        <span className="ms-2">Terminos y Condiciones</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenutermsandconditions" data-bs-parent="#menu">
                        <li className="w-100 action-link-menu pt-2 pb-3">
                          <Link to='/administration/terms-and-conditions' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Ver terminos y condiciones</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  {/* <li className={`
                  ${validateAccessUser(view.VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS,user)}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <Link to='/operation/advances-invoices-reference-detail' className="custom-text-menu h6 px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-edit"></i>
                        <span className="ms-1">Consulta de referencias</span>
                    </Link>
                  </li> */}
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu 
                    ${operationRol === SYSTEM  ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenutermsandconditions" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3 align-items-center">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-file-invoice"></i>
                        <span className="ms-2">T&eacute;rminos y Condiciones</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenutermsandconditions" data-bs-parent="#menu">
                        <li className="w-100 action-link-menu pt-2 pb-3">
                          <Link to='/administration/terms-and-conditions/create' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Cargar t&eacute;rminos y condiciones</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                   <li className={`
                  ${ operationRol === ADMINISTRADOR_ZONA ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <Link to='/operation/advances-invoices-reference-detail' className="custom-text-menu h6 px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-edit"></i>
                        <span className="ms-1">Consulta de referencias</span>
                    </Link>
                  </li> 
          
                  <li className={`
                    nav-item w-100 pt-2 pb-2 ps-3 action-link-menu 
                    ${operationRol === SYSTEM  ? 'd-inline' : 'd-none'}
                  `}>
                      <a href="#submenuimages" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3 align-items-center">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-image"></i>
                        <span className="ms-2">Carrusel</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenuimages" data-bs-parent="#menu">
                        <li className="w-100 action-link-menu pt-2 pb-3">
                          <Link to='/administration/image-list' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Ver Im&aacute;genes</span>
                          </Link>
                        </li>
                        <li className="w-100 action-link-menu pt-2 pb-3">
                          <Link to='/administration/image-list/create' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Cargar Nueva Im&aacute;gen</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  <span className={`
                  ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM ,user) || validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL ,user) || validateAccessUser(view.VIEW_PAYMENT ,user) || validateAccessUser(view.VIEW_PAYMENT_DETAIL ,user) || validateAccessUser(view.VIEW_ADVANCE_PAYMENT ,user) || validateAccessUser(view.VIEW_SALE_ORDER ,user) ? 'd-inline' : 'd-none'}
                  custom-text-title-menu h5
                  `}>Operación</span>
                  <li className={`
                  ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM ,user) || validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                      <a href="#submenuPreviousProgram" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-boxes"></i>
                        <span className="ms-1">Programa previo</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenuPreviousProgram" data-bs-parent="#menu">
                        <li className={`
                        ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM ,user) ? 'd-inline' : 'd-none'}
                        w-100 action-link-menu pt-2 pb-3
                        `}>
                          <Link to='/operation/previous-program' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Ver programa previo</span>
                          </Link>
                        </li>
                        <li className={`
                        ${validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL ,user) ? 'd-inline' : 'd-none'}
                        w-100 action-link-menu pt-2
                        `}>
                          <Link to='/operation/detail-previous-program' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Detalle del programa previo</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  <li className={`
                  ${validateAccessUser(view.VIEW_PAYMENT ,user) || validateAccessUser(view.VIEW_PAYMENT_DETAIL ,user) || validateAccessUser(view.VIEW_ADVANCE_PAYMENT ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                      <a href="#submenuPayment" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-credit-card"></i>
                        <span className="ms-1">Pagos</span>
                        <i className="fas fa-angle-down ms-auto mt-1"></i>
                      </a>
                      <ul className="collapse nav flex-column pb-2 ms-2" id="submenuPayment" data-bs-parent="#menu">
                        <li className={`${ (validateAccessUser(view.VIEW_ADVANCE_PAYMENT ,user) && operationRol !== ADMINISTRADOR_ZONA) ? 'd-block' : 'd-none'} w-100 action-link-menu pt-2 pb-3`}>
                          <Link to='/operation/advance-payment' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Referencia de anticipo</span>
                          </Link>
                        </li>
                        <li className={`
                        ${validateAccessUser(view.VIEW_PAYMENT ,user) ? 'd-inline' : 'd-none'}
                        w-100 action-link-menu pt-2 pb-3
                        `}>
                          <Link to='/operation/payment' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Pago de facturas</span>
                          </Link>
                        </li>
                        <li className={`
                        ${validateAccessUser(view.VIEW_PAYMENT_DETAIL ,user) ? 'd-inline' : 'd-none'}
                        w-100 action-link-menu pt-2 pb-3
                        `}>
                          <Link to='/operation/detail-payment' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Pagos procesados</span>
                          </Link>
                        </li>
                        <li className={`
                        ${validateAccessUser(view.VIEW_ANTICIPATION_PAYMENT ,user) ? 'd-inline' : 'd-none'}
                        w-100 action-link-menu pt-2 pb-3
                        `}>
                          <Link to='/operation/detail-advance-payment' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Pagos de anticipo</span>
                          </Link>
                        </li>
                        <li className={`${ validateAccessUser(view.BILLING_STATEMENT ,user) ? 'd-block' : 'd-none'} w-100 action-link-menu pt-2 pb-3`}>
                          <Link to='/operation/billing-statement' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-none d-sm-inline">Estados de cuenta</span>
                          </Link>
                        </li>
                      </ul>
                  </li>
                  <li className={`
                  ${validateAccessUser(view.VIEW_SALE_ORDER ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <Link to='/operation/sale-order' className="custom-text-menu h6 px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-coins"></i>
                        <span className="ms-1">Órdenes de venta</span>
                    </Link>
                  </li>
                  <li className={`
                  ${validateAccessUser(view.VIEW_DISCOUNT_AND_INVOINCE ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <Link to='/operation/discounts-and-invoices/header' className="custom-text-menu h6 px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-tags"></i>
                        <span className="ms-1">Bonificaciones y Descuentos</span>
                    </Link>
                  </li>
                  <li className={`
                  ${validateAccessUser(view.VIEW_MANAGEMENT_ADVANCES_INVOICES ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <Link to='/operation/advance-and-invoices' className="custom-text-menu h6 px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fa fa-table"></i>
                        <span className="ms-1">Consulta de anticipos</span>
                    </Link>
                  </li>
                  <li className={`
                  ${validateAccessUser(view.VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <Link to='/operation/advances-invoices-and-complements' className="custom-text-menu h6 px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fa fa-table"></i>
                        <span className="ms-1">Consulta de facturas</span>
                    </Link>
                  </li>
                  <span className={`
                  ${validateAccessUser(view.UPDATE_PASS ,user) ? 'd-inline' : 'd-none'}
                  custom-text-title-menu h5
                  `}>Configuración</span>
                  <li className={`
                  ${validateAccessUser(view.UPDATE_PASS ,user) ? 'd-inline' : 'd-none'}
                  nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                  `}>
                    <a href="#submenuAccount" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                      <i className="fas fa-angle-right hide-icon"></i>
                      <i className="fas fa-user"></i>
                      <span className="ms-1">Cuenta</span>
                      <i className="fas fa-angle-down ms-auto mt-1"></i>
                    </a>
                    <ul className="collapse nav flex-column pb-2 ms-2" id="submenuAccount" data-bs-parent="#menu">
                      <li className={`
                      ${validateAccessUser(view.UPDATE_PASS ,user) ? 'd-inline' : 'd-none'}
                      w-100 action-link-menu pt-2 pb-3
                      `}>
                        <Link to='/configuration/account' className="custom-text-menu text-sub-menu px-1">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <span className="d-none d-sm-inline">Cambiar contraseña</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
              </ul>
          </div>
        </>
    )
}
// import React from 'react';
// import { Link } from 'react-router-dom';

// import '../../styles/sideMenuStyle.scss';


// import * as view from '../../constants/models/viewsList';
// import { ADMINISTRADOR, ADMINISTRADOR_ZONA, EMPLEADO, SYSTEM } from '../../constants/models/typeOperationRol';
// import { useAuthInfo } from '../../utils/authUtils';
// import { displayContent, hasAccess } from './NavTopMenu';

// export const SidebarMenu = () => {

//   const {operationRol, userLogged: user} = useAuthInfo()

//     return (
//           <div className="d-flex flex-column align-items-center align-items-sm-start text-white min-vh-100 base-container-menu">
//                <div className="pt-1 pb-1 w-100">
//               <a href="/" className="d-flex align-items-center pb-1 mb-md-0 me-md-auto">
//               <img src="/images/logo.jpg" className="img-fluid" alt="logo" />
//               </a>
//               </div>
//               <ul className="nav nav-pills flex-column w-100 mb-sm-auto mb-0 ps-3 align-items-center align-items-sm-start" id="menu">
//                   <li className="nav-item w-100 pt-2 pb-3 ps-3 action-link-menu">
//                   <Link to='/' className="custom-text-menu h6 px-0 align-middle">
//                   <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-home"></i>
//                         <span className="ms-1">Inicio</span>
//                     </Link>
//                   </li>
//                   <span className={`
//                     custom-text-title-menu h5
//                     ${displayContent(hasAccess(user,view.VIEW_ZONE_ADMIN, view.VIEW_GROUP, view.CREATE_GROUP, view.VIEW_USER, view.UPDATE_USER, view.CREATE_CONTENT, view.VIEW_CONTENT))}
//                       ? 'd-inline' : 'd-none'}
//                   `}>Administración</span>
//                   <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                     ${displayContent(hasAccess(user,view.VIEW_ZONE_ADMIN),operationRol === ADMINISTRADOR_ZONA)}
//                   `}>
//                       <a href="#submenu1" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-user-friends"></i>
//                         <span className="ms-1">Administrador de zona</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenu1" data-bs-parent="#menu">
//                         <li className={`
//                           w-100 action-link-menu pt-2 pb-3
//                           ${displayContent(hasAccess(user,view.VIEW_ZONE_ADMIN),operationRol === ADMINISTRADOR_ZONA)}
//                         `}>
//                           <Link to='/administration/admin-zone' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Ver administrador</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                     ${displayContent(hasAccess(user,view.VIEW_GROUP,view.CREATE_GROUP),operationRol !== EMPLEADO, operationRol !== ADMINISTRADOR_ZONA)}
//                   `}>
//                       <a href="#submenu2" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-user-friends"></i>
//                         <span className="ms-1">Grupos</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenu2" data-bs-parent="#menu">
//                         <li className={`
//                           w-100 action-link-menu pt-2 pb-3
//                            ${displayContent(hasAccess(user,view.VIEW_GROUP) ,operationRol !== EMPLEADO)}
//                         `}>
//                           <Link to='/administration/groups' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Ver grupos</span>
//                           </Link>
//                         </li>
//                         <li className={`
//                           w-100 action-link-menu pt-2
//                          ${displayContent(hasAccess(user,view.CREATE_GROUP),operationRol === ADMINISTRADOR)}
//                         `}>
//                           <Link to='/administration/groups/create' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Nuevo grupo</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                     ${displayContent(hasAccess(user,view.VIEW_USER ,view.UPDATE_USER),operationRol !== EMPLEADO,operationRol !== ADMINISTRADOR_ZONA)}
//                   `}>
//                       <a href="#submenu3" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-users"></i>
//                         <span className="ms-1">Representantes</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenu3" data-bs-parent="#menu">
//                         <li className="w-100 action-link-menu pt-2 pb-3">
//                           <Link to='/administration/users' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Ver representantes</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                      ${displayContent(hasAccess(user,view.CREATE_CONTENT,view.VIEW_CONTENT))}
//                   `}>
//                       <a href="#submenuContent" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="far fa-newspaper"></i>
//                         <span className="ms-1">Contenidos</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenuContent" data-bs-parent="#menu">
//                         <li className="w-100 action-link-menu pt-2 pb-3">
//                           <Link to='/administration/content/marketing' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Avisos</span>
//                           </Link>
//                                                   </li>
//                         {/* <li className="w-100 action-link-menu pt-2 pb-3" id="submenuContent" data-bs-parent="#menu">
//                           <Link to='/administration/content/video' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Videos</span>
//                           </Link>
//                         </li> */}
//                       </ul>
//                   </li>
//                   <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu 
//                     ${displayContent(hasAccess(user,view.VIEW_TERMS_AND_CONDITIONS))}
//                   `}>
//                       <a href="#submenutermsandconditions" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3 align-items-center">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-file-invoice"></i>
//                         <span className="ms-2">T&eacute;rminos y Condiciones</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenutermsandconditions" data-bs-parent="#menu">
//                         <li className="w-100 action-link-menu pt-2 pb-3">
//                           <Link to='/administration/terms-and-conditions' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Ver t&eacute;rminos y condiciones</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   <li className={`
//                   ${displayContent(hasAccess(user,view.VIEW_REFERENCE_PAYMENT))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                     <Link to='/operation/advances-invoices-reference-detail' className="custom-text-menu h6 px-0 align-middle">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-edit"></i>
//                         <span className="ms-1">Consulta de referencias</span>
//                     </Link>
//                   </li>
//                   <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu 
//                     ${displayContent(true,operationRol === SYSTEM )}
//                   `}>
//                       <a href="#submenutermsandconditions" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3 align-items-center">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-file-invoice"></i>
//                         <span className="ms-2">T&eacute;rminos y Condiciones</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenutermsandconditions" data-bs-parent="#menu">
//                         <li className="w-100 action-link-menu pt-2 pb-3">
//                           <Link to='/administration/terms-and-conditions/create' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Cargar t&eacute;rminos y condiciones</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   {/* <li className={`
//                     nav-item w-100 pt-2 pb-2 ps-3 action-link-menu 
//                     ${operationRol === SYSTEM  ? 'd-inline' : 'd-none'}
//                   `}>
//                       <a href="#submenuimages" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3 align-items-center">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-image"></i>
//                         <span className="ms-2">Carrusel</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenuimages" data-bs-parent="#menu">
//                         <li className="w-100 action-link-menu pt-2 pb-3">
//                           <Link to='/administration/image-list' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Ver Im&aacute;genes</span>
//                           </Link>
//                         </li>
//                         <li className="w-100 action-link-menu pt-2 pb-3">
//                           <Link to='/administration/image-list/create' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Cargar Nueva Im&aacute;gen</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li> */}
//                   <span className={`
//                   ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM,view.VIEW_PREVIOUS_PROGRAM_DETAIL,view.VIEW_PAYMENT,view.VIEW_PAYMENT_DETAIL,view.VIEW_ADVANCE_PAYMENT,view.VIEW_SALE_ORDER))}
//                   custom-text-title-menu h5
//                   `}>Operación</span>
//                   <li className={`
//                   ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM ,view.VIEW_PREVIOUS_PROGRAM_DETAIL))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                       <a href="#submenuPreviousProgram" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-boxes"></i>
//                         <span className="ms-1">Programa previo</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenuPreviousProgram" data-bs-parent="#menu">
//                         <li className={`
//                         ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM))}
//                         w-100 action-link-menu pt-2 pb-3
//                         `}>
//                           <Link to='/operation/previous-program' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Ver programa previo</span>
//                           </Link>
//                         </li>
//                         <li className={`
//                        ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM_DETAIL))}
//                         w-100 action-link-menu pt-2
//                         `}>
//                           <Link to='/operation/detail-previous-program' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Detalle del programa previo</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   <li className={`
//                    ${displayContent(hasAccess(user,view.VIEW_PAYMENT,view.VIEW_PAYMENT_DETAIL ,view.VIEW_ADVANCE_PAYMENT))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                       <a href="#submenuPayment" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-credit-card"></i>
//                         <span className="ms-1">Pagos</span>
//                         <i className="fas fa-angle-down ms-auto mt-1"></i>
//                       </a>
//                       <ul className="collapse nav flex-column pb-2 ms-2" id="submenuPayment" data-bs-parent="#menu">
//                         <li className={`${ displayContent(hasAccess(user,view.VIEW_ADVANCE_PAYMENT),operationRol !== ADMINISTRADOR_ZONA) } w-100 action-link-menu pt-2 pb-3`}>
//                           <Link to='/operation/advance-payment' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Referencia de anticipo</span>
//                           </Link>
//                         </li>
//                         <li className={`
//                         ${displayContent(hasAccess(user,view.VIEW_PAYMENT))}
//                         w-100 action-link-menu pt-2 pb-3
//                         `}>
//                           <Link to='/operation/payment' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Pago de facturas</span>
//                           </Link>
//                         </li>
//                         <li className={`
//                         ${displayContent(hasAccess(user,view.VIEW_PAYMENT_DETAIL))}
//                         w-100 action-link-menu pt-2 pb-3
//                         `}>
//                           <Link to='/operation/detail-payment' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Pagos procesados</span>
//                           </Link>
//                         </li>
//                         <li className={`
//                         ${displayContent(hasAccess(user,view.VIEW_ANTICIPATION_PAYMENT))}
//                         w-100 action-link-menu pt-2 pb-3
//                         `}>
//                           <Link to='/operation/detail-advance-payment' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Pagos de anticipo</span>
//                           </Link>
//                         </li>
//                         <li className={`${displayContent(hasAccess(user,view.BILLING_STATEMENT))} w-100 action-link-menu pt-2 pb-3`}>
//                           <Link to='/operation/billing-statement' className="custom-text-menu text-sub-menu px-1">
//                             <i className="fas fa-angle-right hide-icon"></i>
//                             <span className="d-none d-sm-inline">Estados de cuenta</span>
//                           </Link>
//                         </li>
//                       </ul>
//                   </li>
//                   <li className={`
//                   ${displayContent(hasAccess(user,view.VIEW_SALE_ORDER))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                     <Link to='/operation/sale-order' className="custom-text-menu h6 px-0 align-middle">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-coins"></i>
//                         <span className="ms-1">Órdenes de venta</span>
//                     </Link>
//                   </li>
//                   <li className={`
//                   ${displayContent(hasAccess(user,view.VIEW_DISCOUNT_AND_INVOINCE))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                     <Link to='/operation/discounts-and-invoices/header' className="custom-text-menu h6 px-0 align-middle">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fas fa-tags"></i>
//                         <span className="ms-1">Bonificaciones y Descuentos</span>
//                     </Link>
//                   </li>
//                   <li className={`
//                   $${displayContent(hasAccess(user,view.VIEW_MANAGEMENT_ADVANCES_INVOICES))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                     <Link to='/operation/advance-and-invoices' className="custom-text-menu h6 px-0 align-middle">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fa fa-table"></i>
//                         <span className="ms-1">Consulta de anticipos</span>
//                     </Link>
//                   </li>
//                   <li className={`
//                   ${displayContent(hasAccess(user,view.VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                     <Link to='/operation/advances-invoices-and-complements' className="custom-text-menu h6 px-0 align-middle">
//                         <i className="fas fa-angle-right hide-icon"></i>
//                         <i className="fa fa-table"></i>
//                         <span className="ms-1">Consulta de facturas</span>
//                     </Link>
//                   </li>

//                   <span className={`
//                    ${displayContent(hasAccess(user,view.UPDATE_PASS))}
//                   custom-text-title-menu h5
//                   `}>Configuración</span>
//                   <li className={`
//                    ${displayContent(hasAccess(user,view.UPDATE_PASS))}
//                   nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
//                   `}>
//                     <a href="#submenuAccount" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
//                       <i className="fas fa-angle-right hide-icon"></i>
//                       <i className="fas fa-user"></i>
//                       <span className="ms-1">Cuenta</span>
//                       <i className="fas fa-angle-down ms-auto mt-1"></i>
//                     </a>
//                     <ul className="collapse nav flex-column pb-2 ms-2" id="submenuAccount" data-bs-parent="#menu">
//                       <li className={`
//                        ${displayContent(hasAccess(user,view.UPDATE_PASS))}
//                       w-100 action-link-menu pt-2 pb-3
//                       `}>
//                         <Link to='/configuration/account' className="custom-text-menu text-sub-menu px-1">
//                           <i className="fas fa-angle-right hide-icon"></i>
//                           <span className="d-none d-sm-inline">Cambiar contraseña</span>
//                         </Link>
//                       </li>
//                     </ul>
//                   </li>
//               </ul>
//           </div>
//     )
// }